import React from 'react';
import {
  MultiSelectComponents,
} from '@usealloy/component-library';
import type { OptionProps } from '@usealloy/component-library';
import type { AxisHeaderActionOption } from '../types';
import { StyledText } from './styles';
import { ActionType } from '~/dashboard/views/workflows/store/engine/constants';

interface AxisHeaderSingleValueProps extends OptionProps<AxisHeaderActionOption, false> { }
export default function AxisHeaderSingleValue(props: AxisHeaderSingleValueProps) {
  const {
    data: {
      label,
      meta: {
        actionType,
        color,
        name,
      } = {},
    },
  } = props;

  return (
    <MultiSelectComponents.SingleValue {...props}>
      {actionType === ActionType.SERVICE ? (
        <StyledText bold color={color}>{name}:</StyledText>
      ) : (
        <StyledText bold color={color}>{label}: {name}</StyledText>
      )}
    </MultiSelectComponents.SingleValue>
  );
}
